import React  from 'react'
import { Link } from 'react-router-dom'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import MenuIcon from '@material-ui/icons/Menu';


function Nav() {
   

    const showMenu = () =>{
        const button = document.getElementById('responsive_nav');
        if(button.style.display === "block") {
            button.style.display = "none";
            console.log('i worked');
        } else {
            button.style.display = "block"
        }
        
        

    }
    return (
        <div className="nav_container">
            <div className="logo">
                <img src="assets/logo.png" alt="logo" />
            </div>
            <div className="nav_element">
                <ul className='nav_fullmenu'>
                    <li>
                      <Link to="/"> Hotel Deals</Link>
                    </li>

                    <li>
                    <Link to="/grouprates"> Group Hotel Rates</Link>
                        </li>
                    <li>
                    <Link to="/extendedstays"> Extended Stays</Link>
                       </li>
                    <li>
                    <Link to="/hoteldeals"> Meeting Space</Link>
                        </li>
                    <li>
                    <Link to="/more"> More <ArrowDropDownIcon /> </Link>
                       
                    </li>
                    <li>
                    <Link to="/currency">$</Link>
                        </li>
                    <li>
                    <Link to="/flag"> Flag</Link>
                        </li>
                        
                    <li>
                    <Link to="/account"> Account</Link>
                        </li>
                </ul>
                <div className="toggle">
                    <MenuIcon 
                   
                    onClick={showMenu}
                    
                    />
                    <Link to="/account"> Account</Link>
                    <div id="responsive_nav">
                      <ul className='nav_responsive'>
                            <li><Link to="/"> Hotel Deals</Link> </li>
                            <li><Link to="/grouprates"> Group Hotel Rates</Link></li>
                            <li><Link to="/extendedstays"> Extended Stays</Link></li>

                            <li> <Link to="/hoteldeals"> Meeting Space</Link></li>
                            <li><Link to="/more"> More <ArrowDropDownIcon /> </Link></li>
                            <li> <Link to="/currency">$</Link></li>
                            <li> <Link to="/flag"> Flag</Link></li>
                    
                   
                        </ul>
                    </div>
                   
                </div>
            </div>
           
        </div>
    )
}

export default Nav
